import React from "react";
import { Box, Grid } from "@mui/material";
import { useWidth } from "../../../../../libs/hooks";
import { message } from "antd";
import { CardComponent } from "./card-component";
import { TableComponent } from "./table-component";
import {
  workflowThreeCount,
  workflowOneCount,
  workflowTwoCount,
} from "../../../../../libs/apis";
import { CardWelcomeComponent } from "./card-welcome";

export const AdministratorComponent = React.memo(
  ({ options }: { options: any[] }) => {
    const width = useWidth();
    const [valueOne, setValueOne] = React.useState("Hoy");
    const [valueTwo, setValueTwo] = React.useState("Hoy");
    const [valueThree, setValueThree] = React.useState("Hoy");
    const [totalOne, setTotalOne] = React.useState(0);
    const [totalTwo, setTotalTwo] = React.useState(0);
    const [totalThree, setTotalThree] = React.useState(0);
    const [typeProcess, setTypeProcess] = React.useState("all");

    React.useEffect(() => {
      handleGetData();
    }, []);

    const handleGetData = async () => {
      try {
        handleGetOne("hoy");
        handleGetTwo("hoy");
        handleGetThree("hoy");
      } catch (err: any) {
        message.error(err.toString());
      }
    };

    const handleUpdateOne = React.useCallback(
      (val: string) => {
        const fill = options.find((el) => el.value === val);
        if (fill) {
          setValueOne(fill.label);
          handleGetOne(fill.value);
        }
      },
      [options]
    );

    const handleUpdateTwo = React.useCallback(
      (val: string) => {
        const fill = options.find((el) => el.value === val);
        if (fill) {
          setValueTwo(fill.label);
          handleGetTwo(fill.value);
        }
      },
      [options]
    );

    const handleUpdateThree = React.useCallback(
      (val: string) => {
        const fill = options.find((el) => el.value === val);
        if (fill) {
          setValueThree(fill.label);
          handleGetThree(fill.value);
        }
      },
      [options]
    );

    const handleGetOne = async (value: string) => {
      try {
        const { data: dataOne } = await workflowOneCount(value);
        if (!dataOne) return;
        setTotalOne(dataOne.total);
      } catch (err: any) {
        message.error(err.toString());
      }
    };

    const handleGetTwo = async (value: string) => {
      try {
        const { data: dataTwo } = await workflowTwoCount(value);
        if (!dataTwo) return;
        setTotalTwo(dataTwo.total);
      } catch (err: any) {
        message.error(err.toString());
      }
    };

    const handleGetThree = async (value: string) => {
      try {
        const { data: dataThree } = await workflowThreeCount(value);
        if (!dataThree) return;
        setTotalThree(dataThree.total);
      } catch (err: any) {
        message.error(err.toString());
      }
    };

    const changeTypeProcess = (value: string) => {
      if (value === typeProcess) {
        setTypeProcess("all");
      } else {
        setTypeProcess(value);
      }
    };

    return (
      <Grid
        container
        spacing={5}
        justifyContent="center"
        alignContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={6} sm={3}>
          <CardWelcomeComponent />
        </Grid>
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="Proceso 1"
            quantity={totalOne}
            handleUpdate={handleUpdateOne}
            options={options}
            color="tomato"
            value={valueOne}
            typeProcess={typeProcess}
            changeTypeProcess={changeTypeProcess}
          />
        </Grid>
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="Proceso 2"
            quantity={totalTwo}
            handleUpdate={handleUpdateTwo}
            options={options}
            color="orange"
            value={valueTwo}
            typeProcess={typeProcess}
            changeTypeProcess={changeTypeProcess}
          />
        </Grid>
        <Grid item xs={6} sm={2.5}>
          <CardComponent
            width={width}
            title="Proceso 3"
            quantity={totalThree}
            handleUpdate={handleUpdateThree}
            options={options}
            color="green"
            value={valueThree}
            typeProcess={typeProcess}
            changeTypeProcess={changeTypeProcess}
          />
        </Grid>
        <Grid item xs={12}>
          <TableComponent typeProcess={typeProcess} />
        </Grid>
      </Grid>
    );
  }
);
